function stringify(obj) {
    var arr = []
    for (var i in obj) {
    var key = i
    var value = obj[i]
    arr.push(`${key}=${value}`)
    }
    return arr.join('&')
    }
    async function request({
    url,// 请求的地址
    method = 'GET',// 请求的方法
    params = {},// 表示的是地址栏参数
    data = {},// 请求体数据
    headers = {},// 请求头
    dealError = false, //是否处理自己处理请求错误，默认不处理
    onProgress = () => { } // 处理请求进度的
    // success = () => {},// 请求成功的回调
    // fail = () => { }// 请求失败的回调
    }) {
    // 处理地址栏参数
    const paramsstr = stringify(params)
    if (paramsstr) {
    url += `?${paramsstr}`
    }
    // 处理请求头
    const defaultHeaders = {
    'Content-Type': 'application/json',
    ...headers
    }
    // 处理请求体数据
    const cp = defaultHeaders['Content-Type']
    let datastr = null
    // 传递的数据类型为formData格式
    if (Object.getPrototypeOf(data) === FormData.prototype) {
    delete defaultHeaders['Content-Type']
    datastr = data
    } else {
    if (cp.indexOf('application/json') !== -1) {
    datastr = JSON.stringify(data)
    datastr = datastr === '{}' ? null : datastr
    } else if (cp.indexOf('urlencoded') !== -1) {
    datastr = stringify(data)
    datastr = datastr || null
    }
    if (method === 'GET') {
    datastr = null
    }
    }
    const xhr = new XMLHttpRequest()
    xhr.open(method, url, true)
    // 完成请求头的设置
    for (let i in defaultHeaders) {
    xhr.setRequestHeader(i, defaultHeaders[i])
    }
    xhr.send(datastr)
    // 监听progress事件
    xhr.onprogress = onProgress
    try {
    const res = await new Promise((reslove, reject) => {
    xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
    if (xhr.status < 300) {
    let data = null
    const cp = xhr.getResponseHeader('Content-Type')
    // 封装的 ajax 请求方法，接受的参数为：
    // 该方法响应的结果为一个数组，模式如下：
    // ajajx在vue组件中的使用示例
    // 一个分页的使用示例：
    if (!cp) {
    data = xhr.responseText
    } else {
    if (cp.indexOf('application/json') !== -1) {
    data = JSON.parse(xhr.responseText)
    } else if (cp.indexOf('urlencoded') !== -1) {
    data = parse(xhr.responseText)
    } else {
    data = xhr.responseText
    }
    }
    reslove([true, data, xhr])
    } else {
    if (!dealError) { // 采用默认处理
    const { error } = JSON.parse(xhr.responseText)
    alert(error)
    }
    reject([false, {}, xhr])
    }
    }
    }
    })
    return res
    } catch (err) {
    return err
    }
    }
    export default request